import APIClient from './client'
import { camelizeKeys, decamelizeKeys } from 'humps'

const base = (brandId) => `/v1/brands/${brandId}/leads_exports`

const getBrandLeadsExports = (brandId) => {
  return APIClient().get(base(brandId))
    .then(response => camelizeKeys(response.data))
}

const getBrandLeadsExport = (brandId, id) => {
  return APIClient().get(`${base(brandId)}/${id}`)
    .then(response => camelizeKeys(response.data))
}

const createBrandLeadsExport = ({ brandId, payload }) => {
  return APIClient().post(base(brandId), { leads_export: decamelizeKeys(payload) })
    .then(response => camelizeKeys(response.data))
}

const downloadBrandLeadsExport = (brandId, id) => {
  return APIClient().get(`${base(brandId)}/${id}/download`, { responseType: 'blob' })
}

const brandLeadsExportsAPIs = {
  getBrandLeadsExports,
  getBrandLeadsExport,
  createBrandLeadsExport,
  downloadBrandLeadsExport,
}

export default brandLeadsExportsAPIs
